import { Link } from 'react-router-dom'
import { buildConfig } from '../../config/build'
import { getDomainConfig } from '@/utils/domainConfig'
import { QsaveFooter } from './QsaveFooter'

export function Footer() {
  // QSAVE brand gets the editorial dark footer; all other brands keep this one.
  if (getDomainConfig().name === 'QSAVE Project') {
    return <QsaveFooter />
  }
  const formatBuildTime = (isoString: string) => {
    try {
      const date = new Date(isoString)
      // Format as "Jan 17, 2025 at 10:30 AM"
      return date.toLocaleDateString('en-US', {
        month: 'short',
        day: 'numeric',
        year: 'numeric'
      }) + ' at ' + date.toLocaleTimeString('en-US', {
        hour: 'numeric',
        minute: '2-digit',
        hour12: true
      })
    } catch {
      return 'Development Build'
    }
  }
  
  const buildInfo = formatBuildTime(buildConfig.buildTime)
  const isDevMode = buildConfig.environment === 'development'
  
  return (
    <footer className="bg-gray-100 dark:bg-gray-800 border-t border-gray-200 dark:border-gray-700 mb-12">
      <div className="max-w-7xl mx-auto px-4 py-8">
        <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
          {/* Links */}
          <div className="flex space-x-6 text-sm">
            <Link 
              to="/faq" 
              className="text-gray-600 dark:text-gray-400 hover:text-quantum-600 dark:hover:text-quantum-400 transition-colors"
            >
              FAQ
            </Link>
            <Link 
              to="/about" 
              className="text-gray-600 dark:text-gray-400 hover:text-quantum-600 dark:hover:text-quantum-400 transition-colors"
            >
              About
            </Link>
            <Link 
              to="/privacy" 
              className="text-gray-600 dark:text-gray-400 hover:text-quantum-600 dark:hover:text-quantum-400 transition-colors"
            >
              Privacy
            </Link>
            <Link 
              to="/terms" 
              className="text-gray-600 dark:text-gray-400 hover:text-quantum-600 dark:hover:text-quantum-400 transition-colors"
            >
              Ts & Cs
            </Link>
            <Link 
              to="/contact" 
              className="text-gray-600 dark:text-gray-400 hover:text-quantum-600 dark:hover:text-quantum-400 transition-colors"
            >
              Contact
            </Link>
          </div>
          
          {/* Copyright and Build Info */}
          <div className="flex flex-col items-center md:items-end space-y-1">
            <div className="text-xs text-gray-500 dark:text-gray-500">
              {isDevMode ? (
                <span className="text-amber-600 dark:text-amber-400">Development Mode</span>
              ) : (
                <span>Built: {buildInfo}</span>
              )}
            </div>
            <p className="text-sm text-gray-500">
              © 2025 QKey - Post-Quantum Bitcoin
            </p>
          </div>
        </div>
      </div>
    </footer>
  )
}